"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function BlockUserModal(_a) {
    var triggerElement = _a.triggerElement, triggerTitle = _a.triggerTitle, openChat = _a.openChat, updateChat = _a.updateChat;
    var modalRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), isPending = _b[0], setIsPending = _b[1];
    var _c = (0, react_1.useState)(false), isError = _c[0], setIsError = _c[1];
    var handleClick = function () {
        var fieldToPatch = openChat.user_role === "LANDLORD"
            ? { tenant_blocked: true }
            : { landlord_blocked: true };
        setIsPending(true);
        updateChat(openChat, fieldToPatch)
            .then(function (success) { var _a; return success ? (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close() : setIsError(true); })
            .finally(function () { return setIsPending(false); });
    };
    var handleResetModal = function () {
        setIsPending(false);
        setIsError(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { title: triggerTitle, onClick: function () { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.showModal(); } }, triggerElement),
        react_1.default.createElement("dialog", { className: "border p-3 ", ref: modalRef, onClose: handleResetModal },
            react_1.default.createElement("div", { className: "d-flex flex-column gap-3" }, isPending ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("svg", { className: "icon mb-0 align-self-center", width: "18", height: "18" },
                    react_1.default.createElement("use", { href: "#loader" })),
                window.Translator.trans("chat.actions.block_pending", {}, "js"))) : isError ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("button", { className: "align-self-end", onClick: function () { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close(); } },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#close" }))),
                window.Translator.trans("chat.actions.block_error", {}, "js"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("button", { className: "align-self-end", onClick: function () { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close(); } },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#close" }))),
                window.Translator.trans("chat.actions.block_hint", {}, "js"),
                react_1.default.createElement("button", { className: "btn btn--primary", disabled: isPending, onClick: handleClick }, window.Translator.trans("chat.actions.block_chat", {}, "js"))))))));
}
exports.default = BlockUserModal;
